"use client";

import React from "react";

const FertilityLab: React.FC = () => {
  return (
    <div className="flex flex-col items-start w-full box-border bg-[#f3f4ed] px-[30px]">
      <div className="mt-9 w-full text-left mb-5 md:mt-12 md:mb-9">
        <h2 className="title-32 mb-5 text-[#232221]">
          A fertility lab at your fingertips
        </h2>
        <p className="body-17 text-[#474646]">
          Easy-to-read fertility diagnostic results directly on your Inito App,
          in just 10 minutes.
        </p>
      </div>

      <div className="flex flex-col w-full">
        {/* Step 1 */}
        <div className="flex flex-col items-center text-center w-full">
          <div className="w-full md:w-full">
            <video
              src="https://cdn.inito.com/landing_page/section/how_it_works/ng_step_2.mp4"
              autoPlay
              loop
              muted
              preload="metadata"
              title="Dip the Fertility Strip in urine for 15 seconds."
              onContextMenu={() => false}
              playsInline
              className="w-full rounded-[16px]"
            />
            <p className="flex w-full title-18 text-[#232221] text-left gap-2.5 mb-10 pt-4 md:pt-0 md:my-[16px_0_40px]">
              <span>1.</span>Dip the Fertility Strip in urine for 15 seconds.
            </p>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col items-center text-center w-full">
          <div className="w-full md:w-full">
            <video
              src="https://cdn.inito.com/landing_page/section/how_it_works/ng_step_3.mp4"
              autoPlay
              loop
              muted
              preload="metadata"
              title="Insert the Fertility Strip into the InSight Wireless Reader™."
              onContextMenu={() => false}
              playsInline
              className="w-full rounded-[16px]"
            />
            <p className="flex w-full title-18 text-[#232221] text-left gap-2.5 mb-10 pt-4 md:pt-0 md:my-[16px_0_40px]">
              <span>2.</span>Insert the Fertility Strip into the InSight Wireless Reader™.
            </p>
          </div>
        </div>

        {/* Step 3 */}
        <div className="flex flex-col text-center w-full">
          <div className="h-[216px] md:h-[250px] w-full relative rounded-2xl mb-2 md:mb-0">
            <video
              src="https://cdn.inito.com/landing_page/section/how_it_works/ng_step_4.mp4"
              autoPlay
              loop
              muted
              preload="metadata"
              title="Get personalized results on your Inito App in 10 minutes"
              onContextMenu={() => false}
              playsInline
              className="h-[216px] md:h-[250px] w-full rounded-[16px] object-cover"
            />
          </div>
          <p className="flex w-full title-18 text-[#232221] text-left gap-2.5 mb-10 pt-1.5 md:pt-0 md:my-[16px_0_40px]">
            <span>3.</span>Go about your day, and get results delivered straight to your phone. Remove the strip once your test completes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FertilityLab;